/**
 * Error classes thrown by the SDK. Callers match on these rather than
 * parsing raw HTTP responses.
 */

export interface ApiErrorBody {
  ok?: false;
  error?: string;
  userError?: boolean;
  code?: string;
  details?: unknown;
}

export class SdkError extends Error {
  readonly status: number;
  readonly body: ApiErrorBody | undefined;
  constructor(message: string, status: number, body?: ApiErrorBody) {
    super(message);
    this.name = 'SdkError';
    this.status = status;
    this.body = body;
  }
}

export class AuthError extends SdkError {
  constructor(message: string, status: number, body?: ApiErrorBody) {
    super(message, status, body);
    this.name = 'AuthError';
  }
}

export class ValidationError extends SdkError {
  constructor(message: string, status: number, body?: ApiErrorBody) {
    super(message, status, body);
    this.name = 'ValidationError';
  }
}

/** Build the right error subtype for an HTTP status. */
export function errorFromResponse(
  status: number,
  body: ApiErrorBody | undefined
): SdkError {
  const message = body?.error ?? `Request failed with status ${status}`;
  if (status === 401 || status === 403) return new AuthError(message, status, body);
  if (status === 400 || status === 422) return new ValidationError(message, status, body);
  return new SdkError(message, status, body);
}
